import { render, staticRenderFns } from "./DiscrepancyRemarks.vue?vue&type=template&id=3dfc5d9e&"
import script from "./DiscrepancyRemarks.vue?vue&type=script&lang=js&"
export * from "./DiscrepancyRemarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports